import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step17A_Veiculo: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.veiculo) newErrors.veiculo = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ veiculo: data.veiculo });
  };

  const handleFieldChange = (fieldName: string, value: string) => {
    updateField(fieldName as keyof FormData, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">🚗 Você possui veículo próprio ou meio de locomoção que facilite suas vendas e entregas?</p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Sim, carro próprio', value: 'car' },
            { label: 'Sim, moto própria', value: 'motorcycle' },
            { label: 'Não possuo veículo, uso transporte público', value: 'public-transport' },
            { label: 'Não possuo veículo, mas tenho acesso frequente a um', value: 'frequent-access' },
          ]}
          selected={data.veiculo || ''}
          onSelect={(value) => handleFieldChange('veiculo', value)}
        />
        {errors.veiculo && (
          <p className="text-red-600 text-sm mt-2">{errors.veiculo}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step17A_Veiculo;
